(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import { Flex, Div } from "../layout";
import { Heading, Lead } from "../text";
import { Button } from "../buttons";
var StyledFlex = styled(Flex).withConfig({
  displayName: "Empty__StyledFlex",
  componentId: "sc-1x2zolz-0"
})(["flex-direction:column;justify-content:center;align-items:center;background-color:#fefefe;padding:24px;padding-top:32px;@media (min-width:768px){padding:128px;padding-top:96px;}font-weight:200;color:#565656;"]);
var StyledHeading = styled(Heading).withConfig({
  displayName: "Empty__StyledHeading",
  componentId: "sc-1x2zolz-1"
})(["font-weight:500;font-size:32px;text-align:center;"]);

var StyledEmoji = function StyledEmoji(props) {
  var emoji = props.emoji;
  return React.createElement("div", {
    style: {
      fontSize: '48px'
    }
  }, emoji ? emoji : '😱');
};

var Empty = function Empty(props) {
  var action = props.action,
      actionComponent = props.actionComponent,
      handleActionClick = props.handleActionClick,
      heading = props.heading,
      message = props.message,
      emoji = props.emoji,
      secondaryAction = props.secondaryAction,
      handleSecondaryActionClick = props.handleSecondaryActionClick;
  return React.createElement(StyledFlex, props, emoji ? React.createElement(StyledEmoji, {
    emoji: emoji
  }) : null, heading ? React.createElement(StyledHeading, {
    level: 3
  }, heading) : null, React.createElement(Lead, {
    marginBottom: "24px",
    textAlign: "center"
  }, message), action ? React.createElement(Div, null, React.createElement(Button, {
    primary: true,
    onClick: handleActionClick
  }, action)) : null, actionComponent ? actionComponent : null, secondaryAction ? React.createElement(Div, {
    padding: "8px"
  }, React.createElement(Button, {
    transparent: true,
    onClick: handleSecondaryActionClick
  }, secondaryAction)) : null);
};

var _default = Empty;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledFlex, "StyledFlex", "/home/vsts/work/1/s/src/components/containers/Empty.js");
  reactHotLoader.register(StyledHeading, "StyledHeading", "/home/vsts/work/1/s/src/components/containers/Empty.js");
  reactHotLoader.register(StyledEmoji, "StyledEmoji", "/home/vsts/work/1/s/src/components/containers/Empty.js");
  reactHotLoader.register(Empty, "Empty", "/home/vsts/work/1/s/src/components/containers/Empty.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/containers/Empty.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();